import Loading from '@/components/custom/loading'
import StoryEditor from '@/features/story/components/StEditor'
import StEditorOptionbar from '@/features/story/components/StEditorOptionbar'
import {
    StEditorProvider,
} from '@/features/story/components/StEditorProvider'
import StoryEditorSidebar from '@/features/story/components/StEditorSidebar'
import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { SidebarTrigger } from '@/shared/components/ui/sidebar'
// import { getStory } from '@/service/local-db' 
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { WorkspaceLayout } from '@/features/workspace'
import { KEYS } from '@/components/custom/editor/stringKeys/StringKeys'
import { StAIWriterChatProvider } from '@/features/story/components/StAIWriterChatProvider'
import { useStoryQuery } from '../queries/story.queries'
import { useStEditorStore } from '../stores/st-editor.store'


export const StoryEditorProviderWrapper = ({ children }: { children: React.ReactNode }) => (
    <StEditorProvider>{children}</StEditorProvider>
)
export default function StoryPage() {
    return (
        <WorkspaceLayout
            ProviderWrapper={StoryEditorProviderWrapper}
            SidebarComponent={<StoryEditorSidebar />}
            optionBar={<StEditorOptionbar />}
        >
            <StoryPageContent />
        </WorkspaceLayout>
    )
}

export function StoryPageContent() {
    const { storyEntity, setStoryEntity } = useStEditorStore()
    const { project } = useWorkspace()
    const fileName = 'master'
    const router = useNavigate()

    const { data: story, isLoading } = useStoryQuery(project?.id, fileName)

    useEffect(() => {
        if (!project?.id) return
        if (story) {
            setStoryEntity(story)
        } else if (!isLoading && story == null) {
            router(`/workspace/${project.id}/story/add`)
        }
    }, [project, story, setStoryEntity, isLoading, router])

    if (isLoading) {
        return <Loading />
    }

    // If we are redirecting, we might still return null or loading.
    if (!story && !isLoading) return <Loading /> // or null

    return <StoryContent />
}

export function StoryContent() {
    console.log("StoryContent")
    return (
        <div>
            <header className="bg-background sticky top-0 flex h-14 items-center z-50 px-3 ">
                {/* SidebarTrigger on the left */}
                <div className="flex items-center">
                    <SidebarTrigger />
                </div>
            </header>

            <div
                className="flex flex-1 flex-col gap-4 p-4 bg-primary"
                id={KEYS.ST_EDITOR_CONTAINER}
            >
                {/*  <div className="mx-auto h-24 w-full max-w-3xl rounded-xl bg-red-200 " /> */}
                <div className="mx-auto min-h-screen w-full max-w-3xl bg-white mt-15">
                    <StAIWriterChatProvider>
                        <StoryEditor />
                    </StAIWriterChatProvider>
                </div>
            </div>
        </div>
    )
}
